<template>
  <section class="box-layout" v-show="!isLoading">
    <div class="manage-plan__content">
      <header class="content__header">
        <h2>
          {{ $t('userInfo.lnb.managePlan') }}
          <span>{{ $t('userInfo.managePlan.utcDesc')}}</span>
        </h2>
         <div class="button--wrap" v-if="planData && planData.applyType !== 'admin'">
          <ui-button
            class="btn__change"
            :size="'large'"
            :primary="true"
            :disabled="planData.isUnpaid || (planData.next && planData.next.isDowngrade)"
            @click="onViewMorePlans">{{ $t('plan.changePlan') }}</ui-button>
        </div>
        <div class="button--wrap" v-else>
          <ui-button
            class="btn__change"
            :size="'large'"
            :primary="true"
            @click="openContactUs">{{ $t('plan.contactPlan') }}</ui-button>
          <ui-button
            class="btn__change"
            :size="'large'"
            :primary2="true"
            @click="onViewMorePlans">{{ $t('plan.viewMorePlans') }}</ui-button>
        </div>
      </header>
      <div class="content__body" ref="scrollContent">
        <div class="content__top">
          <content-box class="content__plan-in-use" :width="'53.3%'" :height="'252px'">
            <p class="content__title">
              {{ $t('plan.planInUse') }}
              <span v-if="planData.byCoupon" class="coupon-text">{{ $t('common.coupon') }}</span>
            </p>
            <div class="content">
              <div class="content__plan-wrap">
                <div class="content__plan-name">
                  <strong class="plan-name" :class="{ using: planData.hasPlan || planData.inactive }">
                    <template v-if="planData.hasPlan">
                      {{ planData.planName }}
                      <template v-if="planData.planNumber !== 888">
                        <span class="payment-type" v-if="planData.byCoupon">
                          <i class="icon icon--is-coupon"></i>
                          <ui-tooltip arrowBottom arrowCenter>{{ $t('billing.coupon') }}</ui-tooltip>
                        </span>
                        <span class="payment-type" v-if="planData.isCardPlan">
                          <i class="icon icon--is-card"></i>
                          <ui-tooltip arrowBottom arrowCenter>{{ $t('billing.card') }}{{ $t('billing.subscription') }}</ui-tooltip>
                        </span>
                        <span class="payment-type" v-if="planData.isWirePlan">
                          <i class="icon icon--is-wire-transfer"></i>
                          <ui-tooltip arrowBottom arrowCenter>{{ $t('billing.wire') }}</ui-tooltip>
                        </span>
                        <span class="payment-type" v-if="planData.byAdmin">
                          <i class="icon icon--is-gift"></i>
                          <ui-tooltip arrowBottom arrowCenter>{{ $t('billing.admin') }}</ui-tooltip>
                        </span>
                        </template>
                    </template>
                    <template v-else-if="planData.inactive">
                      {{ $t('plan.inactive') }}
                    </template>
                    <template v-else>{{ $t('plan.noPlanInUse') }}</template>
                  </strong>
                </div>
                <div v-if="planData.planNumber !== 300 || planData.planNumber !== 401  " class="content__my-plan" :class="{noCredit: !(aiReportCredit && aiReportCredit.total)}">
                  <div class="content__my-plan-title">AI DOCENT</div>
                  <template v-if="aiReportCredit && aiReportCredit.total">
                    <div class="contents__ai-report-info">
                      <span class="brand-mark">{{ aiReportCredit.total -  aiReportCredit.count }}</span> / {{ aiReportCredit.total }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="contents__no-ai-report" v-html="$t('plan.cxReport.noCxReport')"></div>
                  </template>
                </div>
              </div>
              <div class="content_outer">
                <div class="plan-period" v-if="!planData.inactive">
                  <p class="label">{{ $t('plan.subscriptionTerms') }}</p>
                  <p v-if="planData.hasPlan" class="value">
                    <time datetime="">{{ planData.startDate | dashDate }}</time> ~
                    <time datetime="">{{ planData.endDate | dashDate }}</time>
                  </p>
                  <p v-else class="value">-</p>
                </div>
                <div class="plan-period" v-else>
                  <p class="label">{{ $t('plan.inactiveLabel') }}</p>
                  <p class="value">
                    {{ $t('plan.appliedAt', { startDate: getLocaleDateStr(planData.startDate) }) }}
                  </p>
                </div>

                <div class="subscribe--wrap" v-if="planData && planData.hasPlan">
                  <template v-if="planData.next">
                    <template v-if="planData.next.isDowngrade">
                      <div class="description-area">
                        <p class="label">
                          {{ $t('plan.downgradeLabel', { planName: planData.next.planName }) }}
                        </p>
                        <p class="value">
                          {{ $t('plan.startAt', { startDate: getLocaleDateStr(planData.next.startDate) }) }}
                        </p>
                      </div>
                      <div class="button-area" v-if="planData.next.isCardPlan || planData.next.bySystem">
                        <ui-button v-if="planData.applyType !== 'admin'"
                                    :size="'large'"
                                    @click="onCancelPlanChange">
                          {{ $t('plan.cancelSchedule') }}
                        </ui-button>
                        <ui-button v-if="planData.applyType === 'admin'" :size="'large'"
                                    @click="openContactUs(true)">
                          {{ $t('common.contactUs') }}
                        </ui-button>
                      </div>
                      <div class="button-area" v-else>
                        <ui-button :size="'large'" @click="openContactUs(true)">
                          {{ $t('common.contactUs') }}
                        </ui-button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="description-area">
                        <p class="label">
                          {{ $t('plan.nextPlanLabel', { planName: planData.next.planName }) }}
                        </p>
                        <p class="value">
                          {{ $t('plan.startAt', { startDate: getLocaleDateStr(planData.next.startDate) }) }}
                        </p>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="planData.isUnpaid">
                    <div class="description-area">
                      <p class="label">
                        {{ $t('plan.paymentFailed') }}
                      </p>
                      <p class="value">
                        {{ $t('plan.checkPaymentMethod') }}
                      </p>
                    </div>
                    <div class="button-area">
                      <ui-button :size="'large'"
                                  @click="onRegisterCard">
                        {{ $t('billing.paymentDetail.update') }}
                      </ui-button>
                    </div>
                  </template>
                </div>
                <div class="subscribe--wrap" v-else-if="planData && planData.inactive">
                  <div class="button-area">
                    <ui-button :size="'large'"
                                :primary2="true"
                                @click="onEndInactive">
                      {{ $t('plan.endInactive') }}
                    </ui-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="referral">
              <template v-if="currentReferral || nextReferral">
                <i v-if="isReferralInvalid" class="icon icon--info-red" v-btf-tooltip:top.start="{ contents: $t('referral.invalidNotice'), offset: -16 }"></i>
                <span class="referral-label">{{ $t('referral.referral') }} :</span>
                <span v-if="isReferralInvalid" class="referral-code invalid">{{ $t('referral.invalid') }}</span>
                <span v-else-if="currentReferral" class="referral-code current">{{ currentReferral }}</span>
                <span v-else class="referral-code invalid">{{ $t('referral.noReferrer') }}</span>
                <button class="edit-btn" @click="isModifyingReferral = true">
                  <i class="icon icon--pencil-dark"></i>
                </button>
                <template v-if="nextReferral !== currentReferral">
                  <i class="icon icon--arrow-body-dark-gray"></i>
                  <span>{{ $t('referral.schedule') }}</span>
                  <span v-if="nextReferral" class="referral-code new">{{ nextReferral }}</span>
                  <span v-else class="referral-code invalid">{{ $t('referral.noReferrer') }}</span>
                  <button class="cancel-btn" @click="onRevertReferral">
                    <i class="icon icon--close14"></i>
                  </button>
                </template>
              </template>
              <template v-else>
                <i class="icon icon--bell-till"></i>
                <span>{{ $t('referral.benefit') }}</span>
                <button class="apply-btn" @click="isRegisteringReferral = true">
                  {{ $t('referral.register.title') }}
                </button>
              </template>
            </div>
          </content-box>
          <content-box class="content__monthly-pv" :width="'28.3%'" :height="'252px'">
            <p class="content__title">{{ $t('plan.monthlyPv') }}</p>
            <div class="content">
              <div class="battery--wrap">
                <battery-indicator isLargeSize/>
                <span class="value__pv">
                <template v-if="planData.hasPlan">{{ pvPercentage }}%</template>
                <template v-else>- %</template>
              </span>
              </div>
              <p class="remain-pv">
                <template v-if="planData.hasPlan">
                  <strong>{{ (userData.remainPv >= 0 ? userData.remainPv : 0) | thousand }} PV</strong>/ {{ userData.pvLimit | thousand }} PV
                </template>
                <template v-else>
                  <strong>- PV</strong>/ - PV
                </template>
              </p>
              <div class="plan-period">
                <p v-if="planData.hasPlan && !planData.inactive && planData.monthlyStartDate && planData.monthlyEndDate">
                  <time datetime="">{{ planData.monthlyStartDate | dashDate }}</time> ~
                  <time datetime="">{{ planData.monthlyEndDate | dashDate }}</time>
                </p>
                <div v-else class="plan-period">&nbsp;</div>
              </div>
            </div>
            <div class="button--wrap">
              <ui-button primary4
                          :disabled="!planData.canChargePv"
                          :iconName="'icon--pv-plug'"
                          @click="onChargePv()">
                {{ $t('common.chargePv') }}
              </ui-button>
            </div>
          </content-box>
          <content-box class="content__jam" :width="'18.4%'" :height="'252px'">
            <p class="content__title">{{ $t('plan.myJam') }}
              <ui-icon-tooltip v-if="expireJamList.length > 0"
                                :iconSize="'yellow'"
                                arrowTop
                                arrowCenter>
                <span v-html="$t('common.expireJam')"></span>
              </ui-icon-tooltip>
            </p>
            <div class="content">
              <div class="jam--wrap" @mouseenter="showJamTooltip = true" @mouseleave="showJamTooltip = false">
                <div class="icon icon--jam--64px">
                </div>
                <ui-tooltip v-if="showJamTooltip" arrowTop arrowCenter :transition-type = "null">
                  <span v-html="$t('plan.jamChargingGuide', { link: `https://forum.beusable.net/ko/solomon/post`})"></span>
                </ui-tooltip>
              </div>
              <div class="remain-jam">
                <div><span class="value">{{ remainJam | thousand }}</span> {{ $t('plan.jamAmount') }}</div>
              </div>
            </div>
            <div class="button--wrap">
              <ui-button primary4
                          class="button"
                          :disabled="!planData.hasPlan"
                          :iconName="'icon--plus-red'"
                          @click="onChargePv('jam')">
                {{ $t('plan.chargeJam') }}
              </ui-button>
            </div>
          </content-box>
        </div>

        <div class="content__middle">
          <div class="chart-type">
            <button :class="{ on: this.currentChart === 'plan' }"
                    @click="onSelectChartType('plan')">
              {{ $t('plan.planChart') }}
            </button>
            <button :class="{ on: this.currentChart === 'pv' }"
                    @click="onSelectChartType('pv')">
              {{ $t('plan.pvChart') }}
            </button>
          </div>

          <plan-chart v-if="this.currentChart === 'plan'"
                      :key="refreshKey" />

          <remain-pv-chart v-if="this.currentChart === 'pv'"
                            :startDate="planData.startDate"
                            :key="refreshKey" />
        </div>
        <back-to-top refName="scrollContent"/>
      </div>

      <dimmed v-if="useDimmed  && !registerData">
        <plan-subscription v-if=" (isChangingPlan && planData.applyType === 'admin')|| (isChangingPlan && !planData.isUnpaid && !(planData.next && planData.next.isDowngrade))"
                            :initialPlan="initialPlan"
                            :apply-data="applyPlanData"
                            :remain-credit="aiReportCredit"
                            @onConfirm="onPlanChangeConfirm"
                            @openRegCard="openRegCard"
                            @closeLayer="closePlan" />

        <charge-pv v-if="isChargingPv"
                    :remainJam="remainJam"
                    :topUpJam="topUpJam"
                    @registerDataChange="onRegisterDataChange"
                    @remainJamChange="onRemainJamChange"
                    @onTopUpJam="topUpJam = $event"
                    @showTopUpAlert="showTopUpAlert = $event"
                    @result="TopUpResult = $event"
                    @onConfirm="onChargePvConfirm"
                    @closeLayer="isChargingPv = false, topUpJam = false" />

        <change-cancel v-if="isPlanCanceled"
                        @closeLayer="closePlan" />
        <referral-register
          v-if="isRegisteringReferral || isModifyingReferral"
          :currentCode="currentReferral"
          :type="isRegisteringReferral ? 'register' : 'modify'"
          @close="closeReferral"
        />
      </dimmed>

      <register-card v-if="registerData"
                    :userData="userData"
                    :registerData="registerData"
                    @onRegisterSuccess="onRegisterSuccess"
                    @onRegisterCanceled="onRegisterCanceled"
                    @onRegisterFailed="onRegisterFailed"/>
    </div>

    <dimmed v-if="showLoginAlert">
      <alert :title="$t('dialog.userInfo.planUpdatingManagePlan.title')"
              :description="$t('dialog.userInfo.planUpdatingManagePlan.description', { today: todayString })"
              :submit="$t('common.confirm')"
              @onSubmit="closeLoginAlert" />
    </dimmed>

    <dimmed v-if="showTopUpAlert">
    <alert :icon="TopUpResult ? 'icon--validation-pass' : 'icon--alert'"
            :title="TopUpResult ? $t('plan.alert[0].title') : $t('plan.alert[1].title')"
            :description="TopUpResult ? $t('plan.alert[0].description') : $t('plan.alert[1].description')"
            :submit="$t('common.confirm')"
            @onSubmit="closeTopUpAlert" />
    </dimmed>
    <dimmed v-if="stateApplyPlan">
    <!-- <dimmed v-if="stateApplyPlan"> -->
      <div class="user-applied-plan">
        <div class="plan-title">{{ $t('plan.pricing.total') }}</div>
        <div class="plan-info-wrap">
          <div class="plan-name">{{ applyPlanData.planName }}</div>
          <div class="plan-pv-info">{{ applyPlanData.pvText }}</div>
          <div class="plan-pv-info">{{ applyPlanData.cxReportText }}</div>
        </div>
        <div class="plan-detail-wrap">
          <div class="plan-discount-info">
            <div class="info-list">
              <div v-if="applyPlanData.referralError" class="info-error">
                {{ $t(`common.validationErrorText.${applyPlanData.referralError}`) }}
              </div>
              <div v-else-if="applyPlanData.referral" class="info-item">
                <div class="info-name">{{ $t('plan.pricing.referralDiscount') }}</div>
                <div class="info-value">{{ applyPlanData.originPrice * 0.1 | thousand}}{{ $t('plan.pricing.currencyUnit') }}</div>
              </div>
              <div class="info-item">
                <div class="info-name">{{ $t('plan.pricing.planFee') }}</div>
                <div class="info-value">{{ applyPlanData.originPrice | thousand}}{{ $t('plan.pricing.currencyUnit') }}</div>
              </div>
              <div v-if="applyPlanData.isYearly === 'true'" class="info-item">
                <div class="info-name">{{ $t('plan.pricing.annualDiscount') }}</div>
                <div class="info-value">{{ $t('plan.pricing.tenPercentDiscount') }}</div>
              </div>
            </div>
          </div>
          <div class="plan-price-info">
            <div class="final-price">{{ applyPlanData.price | thousand }}{{ $t('plan.pricing.currencyUnit') }}</div>
            <div class="price-per-month">{{ $t('plan.pricing.monthlyFee') }} {{ setPricePerMonth | thousand }}{{ $t('plan.pricing.currencyUnit') }} / {{ $t('payment.noVat') }}</div>
            <template v-if="paymentType === 'contact'">
              <button class="price-payment-btn ui-btn primary size--large" @click="onChangePlan(false)">{{ $t('pricing.contactUs') }}</button>
            </template>
            <template v-else>
              <button class="price-payment-btn ui-btn primary size--large" @click="onChangePlan(false)">{{ $t('common.confirm') }}</button>
            </template>
          </div>
        </div>
      </div>
    </dimmed>
  </section>
</template>

<script>
import { format, addDays } from 'date-fns'
import { create } from 'vue-modal-dialogs'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { getLocaleDateStr, openContactUs, openPricing } from '@/libs/utils'
import { getCardInfo, registerSuccessToss } from '@/api/card'
import { purchaseCredit, updatePlan, cancelChange, getCurrentNext } from '@/api/userPlan'
import { EventBus } from '@/libs/event-bus'
import { getRemainJam, onChargePvByJam, getExpireJamList } from '@/api/jam'
import { heatmapDocentCheck } from '@/api/ai'
import { setReferralCode, checkReferValidate } from '@/api/referral'
import { confirmPayment } from '@/libs/confirmPayment'
import axios from 'axios'

import AppDialog from '@/components/ui/AppDialog'
import Alert from '@/components/ui/Alert'
import Dimmed from '@/components/ui/Dimmed'
import ContentBox from '@/components/ui/ContentBox'
import PlanChart from '@/components/user-info/manage-plan/PlanChart'
import RemainPvChart from '@/components/user-info/manage-plan/RemainPvChart'
import PlanSubscription from '@/components/user-info/manage-plan/PlanSubscription'
import ChangeCancel from '@/components/user-info/manage-plan/ChangeCancel'
import ChargePv from '@/components/user-info/manage-plan/ChargePv'
import ReferralRegister from '@/components/user-info/manage-plan/ReferralRegister'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import BatteryIndicator from '@/components/header/BatteryIndicator'
import RegisterCard from '@/components/user-info/manage-plan/RegisterCard'
import UiTooltip from '@/components/ui/UiTooltip'
import UiIconTooltip from '@/components/ui/UiIconTooltip'

const openDialog = create(AppDialog)

export default {
  components: {
    UiTooltip,
    Alert,
    Dimmed,
    ContentBox,
    BackToTop,
    UiButton,
    BatteryIndicator,
    PlanChart,
    RemainPvChart,
    PlanSubscription,
    ChangeCancel,
    ChargePv,
    RegisterCard,
    ReferralRegister,
    UiIconTooltip
  },
  data () {
    return {
      // openTossView: false,
      isLoading: true,
      isChangingPlan: false,
      isChargingPv: false,
      isRegisteringReferral: false,
      isModifyingReferral: false,
      isReferralInvalid: false,
      confirmContentType: null,
      registerData: null,
      registerCallback: null,
      pvHistory: null,
      isPlanCanceled: false,
      currentChart: 'plan',
      paymentType: 'card',
      planDataToShow: null,
      initialPlan: false,
      refreshKey: new Date().toString(),
      showLoginAlert: false,
      showTopUpAlert: false,
      TopUpResult: false,
      topUpJam: false,
      remainJam: 0,
      expireJamList: [],
      applyPlanData: null,
      stateApplyPlan: false,
      currentUserPlan: null,
      aiReportCredit: null,
      showJamTooltip: false,
      currentPlanData: null,
      nextPlanData: null
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showStickyData'
    ]),
    ...mapGetters([
      'creditData'
    ]),
    todayString () {
      return format(new Date(), 'YYYY-MM-DD')
    },
    pvPercentage () {
      return this.creditData.percentage >= 0 ? this.creditData.percentage : 0
    },
    useDimmed () {
      if (this.isChangingPlan && this.planData.applyType === 'admin') return true
      return (this.isChangingPlan && !this.planData.isUnpaid && !(this.planData.next && this.planData.next.isDowngrade)) ||
              this.isChargingPv ||
              this.isPlanCanceled ||
              this.isRegisteringReferral ||
              this.isModifyingReferral
    },
    paymentBtnType () {
      let applyType = 'contact'
      if (!this.currentPlanData) return applyType
      if (this.currentPlanData.applyType !== 'admin' && !this.currentPlanData.bFree && this.currentPlanData.planGroup === 'PAID') {
        applyType = 'apply'
      }
      if (this.currentPlanData.planName === 'Terminate' || this.currentPlanData.planName === 'TrialOver') {
        applyType = 'apply'
      }
      if (this.applyPlanData.isYearly === 'true' || this.applyPlanData.paymentType === 'bank') {
        applyType = 'contact'
      }
      return applyType
    },
    setPricePerMonth () {
      if (this.applyPlanData.isYearly === 'true') {
        return Math.round(this.applyPlanData.price.replace(/,/g, '') / 12)
      } else {
        return this.applyPlanData.price
      }
    },
    currentReferral () {
      return this.currentPlanData ? this.currentPlanData.referral : null
    },
    nextReferral () {
      return this.nextPlanData ? this.nextPlanData.referral : null
    }
  },
  async created () {
    this.setTossCard()
    if (this.$route.query.orderId && this.$route.query.amount && this.$route.query.paymentKey) {
      const requestData = {
        orderId: this.$route.query.orderId,
        amount: this.$route.query.amount,
        paymentKey: this.$route.query.paymentKey
      }
      const responseJson = await confirmPayment(requestData)
      const paymentLogData = {
        'serviceType': 'ba',
        'data': responseJson
      }
      if (responseJson.code) {
        paymentLogData.success = false
      } else {
        paymentLogData.success = true
        paymentLogData.pvCount = parseInt(responseJson.orderName.split(' ')[3])
        paymentLogData.totalPrice = responseJson.totalAmount
      }
      // purchaseCreditTossWidget(paymentLogData).then(resp => {
      //   this.isChargingPv = false
      //   this.setPlanInfo()
      //   this.refreshKey = new Date().toString()
      //   openDialog({
      //     dialogType: 'plan.pvCompleted',
      //     ok: this.$t('common.confirm')
      //   }).then(() => {
      //     this.$router.push({ name: 'managePlan' })
      //   })
      // }).catch(err => {
      //   this.isChargingPv = false
      //   if (!err.isHandled) {
      //     let errorMessage = 'plan.registerCardFailed'
      //     switch (err.message) {
      //       case 'No Current Plan found':
      //         errorMessage = 'plan.noCurrentPlanFound'
      //     }
      //     openDialog({
      //       dialogType: errorMessage
      //     }).then(() => {
      //       this.$router.push({ name: 'managePlan' })
      //     })
      //   }
      // })
    }
    this.getLocaleDateStr = getLocaleDateStr
    this.loadData()

    setTimeout(() => {
      this.setPlanInfo().then(() => {
        this.isLoading = false
        const action = this.$route.params.action

        if (action) {
          this.handlePlanAction(action)
        }
      })
    }, 300)

    EventBus.$on('onActionTrigger', (triggeredAction) => {
      if (triggeredAction) {
        this.handlePlanAction(triggeredAction)
      }
    })

    const now = new Date()
    if (now.getHours() <= 1) {
      if (!this.planData || !this.planData.next || format(this.planData.next.startDate, 'YYYY-MM-DD') === format(now, 'YYYY-MM-DD')) {
        this.showLoginAlert = true
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    const action = to.params.action

    if (action) {
      this.handlePlanAction(action)
    }
    next()
  },
  async mounted () {
    if (this.$route.query.planNumber) {
      this.applyPlanData = this.$route.query

      if (this.applyPlanData.referral) {
        let isReferralValid = null
        await checkReferValidate({ referral: this.applyPlanData.referral, userId: this.userData.userId })
          .then(res => {
            isReferralValid = res
            // res === true -> 유효한 추천인 코드
            // res === false -> 자신의 추천인 코드와 중복
            // res === null -> 유효하지 않은 추천인 코드
          })
          .catch(e => {
            console.error(e)
          })
        if (!isReferralValid) {
          this.applyPlanData.referral = null
          this.applyPlanData.referralError = isReferralValid === false ? 'duplicatedReferralCode' : 'invalidReferralCode'
          this.applyPlanData.price = this.applyPlanData.price / 0.9
        }
      }

      await this.$router.replace({ name: 'managePlan', query: {} })
      await this.onChangePlan(false)
    }
  },
  methods: {
    ...mapMutations([
      'setShowStickyData'
    ]),
    ...mapActions([
      'storeUserData',
      'storePlanData'
    ]),
    loadData () {
      this.setRemainJam()
      this.setExpireJamList()
      this.getCurrentNextPlan()
      this.getRemainCreditData()
    },
    getCurrentNextPlan () {
      getCurrentNext({}, true).then(res => {
        this.currentPlanData = res.currentPlan
        this.nextPlanData = res.nextPlan

        if (res.currentPlan.referral) {
          checkReferValidate({ referral: res.currentPlan.referral, userId: this.userData.userId })
            .then(res => {
              this.isReferralInvalid = !res
            })
            .catch(e => {
              this.isReferralInvalid = true
              console.error(e)
            })
        }
      })
    },
    async getRemainCreditData () {
      const params = {
        'category': 'journeymapMCP',
        'serviceType': 'ba'
      }
      try {
        const res = await heatmapDocentCheck(params)
        this.aiReportCredit = res
      } catch (e) {
        console.log(e)
      }
    },
    setTossCard () {
      if (this.$route.query.customerKey && this.$route.query.authKey) {
        let secretKey = process.env.VUE_APP_TOSS_API_BILLLING_SEC
        secretKey = Buffer.from(secretKey).toString('base64')
        const url = process.env.VUE_APP_TOSS_API_URL + '/v1/billing/authorizations/issue'

        const headers = {
          Authorization: 'Basic ' + secretKey, // 예시 토큰
          'Content-Type': 'application/json'
        }
        axios.post(url, this.$route.query, { headers }).then(resp => {
          resp.data.isToss = true
          registerSuccessToss(resp.data).then(() => {
            this.$router.push({ name: 'managePlan', query: {} })
          })
        })
      } else if (this.$route.query.code && this.$route.query.message) {
        openDialog({
          dialogType: 'plan.registerCardFailed',
          ok: this.$t('common.confirm')
        }).then(() => {
          this.$router.push({ name: 'managePlan', query: {} })
        })
      }
    },
    closeLoginAlert () {
      this.showLoginAlert = false
    },
    closeTopUpAlert () {
      this.showTopUpAlert = false
    },
    closeApplyPlan () {
      this.stateApplyPlan = false
    },
    openRegCard () {
      if (this.planData.applyType === 'admin') return
      this.registerData = {
        customerUid: null
      }
    },
    setPlanInfo () {
      return this.storePlanData().then(data => {
        return this.storeUserData()
      }).then(() => {
        EventBus.$emit('onLoading', false)
      }).catch(err => {
        EventBus.$emit('onLoading', false)
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onSelectChartType (value) {
      this.currentChart = value
    },

    onRegisterCard () {
      this.$router.push({ name: 'billing', params: { action: 'registerCard' } })
    },

    openContactUs (isDowngrade) {
      let form = this.$t('plan.contactForm')
      if (isDowngrade === true) {
        form = this.$t('plan.downgradeForm', { planName: this.planData.planName })
      }
      openContactUs(this.userData, form, this.planData.applyType === 'admin')
    },

    onViewMorePlans () {
      openPricing()
    },

    onRegisterSuccess () {
      this.registerData = null
      if (this.registerCallback) {
        this.registerCallback()
        setTimeout(() => {
          this.registerCallback = null
        }, 100)
      }
    },

    onRegisterCanceled () {
      this.registerData = null
      this.isChangingPlan = false
    },

    onRegisterFailed (result) {
      this.registerData = null

      openDialog({
        dialogType: 'plan.registerCardFailed',
        ok: this.$t('common.confirm')
      })
    },

    onChangePlan (initialPlan) {
      // 변경 가능 하고 , 미납 상태가 아니면서 다음 플랜이 다운그레이드가 아닌경우
      if (this.planData.canChange && !this.planData.isUnpaid && !(this.planData.next && this.planData.next.isDowngrade)) {
        this.initialPlan = initialPlan || false
        this.isChangingPlan = true
      }
      this.initialPlan = initialPlan || false
      this.isChangingPlan = true
      if (this.stateApplyPlan) {
        this.closeApplyPlan()
      }
    },
    closePlan () {
      this.isPlanCanceled = false
      this.isChangingPlan = false
      this.applyPlanData = null
    },
    async onPlanChangeConfirm (newPlan, pvLimits) {
      let requestData = {
        planUpdateTo: newPlan.planNumber,
        referral: newPlan.referral ? newPlan.referral : null,
        pvLimits
      }
      if (newPlan.planNumber === 1000) {
        requestData = { ...requestData,
          pv: newPlan.pvLimit,
          price: newPlan.price,
          aiReportCredit: newPlan.aiReportCredit,
          [newPlan.grade]: true
        }
      }

      if (newPlan.planNumber === 300) {
        requestData.referral = this.nextReferral
      }

      if (newPlan.referral && this.currentReferral !== newPlan.referral) {
        let referralSet = false

        await setReferralCode({
          referral: newPlan.referral,
          other: false,
          terms: true,
          planUpdateTo: newPlan.planNumber
        })
          .then(res => {
            if (res) {
              referralSet = true
            }
          })
          .catch(e => {
            console.error(e)
          })

        if (!referralSet) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      }

      const updateStart = () => {
        updatePlan(requestData, true).then(result => {
          this.isChangingPlan = false
          this.setPlanInfo()
          this.refreshKey = new Date().toString()
          let dialogType = 'plan.planCompleted'
          if (result.compare.isDowngrade) {
            dialogType = 'plan.planScheduleCompleted'
          }
          openDialog({
            dialogType,
            ok: this.$t('common.confirm')
          })
        }).catch(err => {
          this.isChangingPlan = false
          console.log(err, 'err')
          if (!err.isHandled) {
            let errorMessage = 'plan.registerCardFailed'
            openDialog({
              dialogType: errorMessage
            })
          }
        }).finally(() => {
          this.loadData()
        })
      }

      if (newPlan.bFree) {
        updateStart()
      } else {
        getCardInfo('ba').then(data => {
          if (!data || (!data.iamportCustomerUid && !data.tossBillingKey)) {
            this.registerData = {
              customerUid: null
            }
            this.isChangingPlan = false
          } else {
            updateStart()
          }
        }).catch(err => {
          if (!err.isHandled) {
            openDialog({
              dialogType: 'common.error'
            })
          }
          this.isChangingPlan = false
        })
      }
    },
    onCancelPlanChange () {
      getCardInfo('ba').then(async data => {
        if (!data || (!data.iamportCustomerUid && !data.tossBillingKey)) {
          this.registerData = {
            customerUid: null
          }
          this.registerCallback = this.onCancelPlanChange
        } else {
          const params = {}

          if (this.currentReferral) {
            params.referral = this.currentReferral
            if (this.currentReferral !== this.nextReferral) {
              try {
                await this.onRevertReferral()
              } catch (err) {
                openDialog({
                  dialogType: 'common.error'
                })
                return
              }
            }
          }
          cancelChange(params, true).then(result => {
            this.setPlanInfo()
            this.refreshKey = new Date().toString()
            this.isPlanCanceled = true
          }).catch(err => {
            if (!err.isHandled) {
              let errorMessage = 'plan.registerCardFailed'
              switch (err.message) {
                case 'No Current Plan found':
                  errorMessage = 'plan.noCurrentPlanFound'
              }
              openDialog({
                dialogType: errorMessage
              })
            }
          })
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },

    onChargePv (value) {
      this.isChargingPv = true
      if (value) {
        this.topUpJam = true
      }
    },

    onChargePvConfirm (chargePv) {
      if (chargePv.openTossView === true) {
        this.openTossView = true
        // this.tossData = chargePv
      } else {
        if (chargePv.type === 'pv') {
          getCardInfo('ba').then(data => {
            if (!data || !data.iamportCustomerUid) {
              this.registerData = {
                customerUid: null
              }
            } else {
              purchaseCredit({
                pvCount: chargePv.pv,
                totalPrice: chargePv.price
              }).then(data => {
                this.isChargingPv = false
                this.setPlanInfo()
                this.refreshKey = new Date().toString()
                openDialog({
                  dialogType: 'plan.pvCompleted',
                  ok: this.$t('common.confirm')
                })
              }).catch(err => {
                this.isChargingPv = false
                if (!err.isHandled) {
                  let errorMessage = 'plan.registerCardFailed'
                  switch (err.message) {
                    case 'No Current Plan found':
                      errorMessage = 'plan.noCurrentPlanFound'
                  }
                  openDialog({
                    dialogType: errorMessage
                  })
                }
              })
            }
          }).catch(err => {
            if (!err.isHandled) {
              openDialog({
                dialogType: 'common.error'
              })
            }
            this.isChargingPv = false
          })
        } else {
          onChargePvByJam({
            jamCount: chargePv.jamCount,
            pvCount: chargePv.pvCount
          }, true).then(res => {
            this.isChargingPv = false
            this.setRemainJam()
            this.setPlanInfo()
            this.refreshKey = new Date().toString()
            openDialog({
              dialogType: 'plan.pvCompleted',
              ok: this.$t('common.confirm')
            })
          }).catch(err => {
            if (!err.isHandled) {
              openDialog({
                dialogType: 'common.error'
              })
            }
            this.isChargingPv = false
          })
        }
      }
    },
    onRemainJamChange () {
      this.setRemainJam()
    },
    onEndInactive () {
      this.setShowStickyData(true)
    },
    handlePlanAction (action) {
      if (action !== 'chargePv' && this.planData.isWirePlan) {
        return
      }

      switch (action) {
        case 'contactPlan':
          this.openContactUs()
          break
        case 'cancelPlanChange':
          this.onCancelPlanChange(true)
          break
        case 'changePlan':
          this.onChangePlan()
          break
        case 'downgradePlan':
          this.onChangePlan(300)
          break
        case 'chargePv':
          this.onChargePv()
          break
      }
    },
    setRemainJam () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum,
        serviceType: 'ba'
      }
      getRemainJam(payload, true).then(res => {
        this.remainJam = res.paidCount + res.freeCount
        EventBus.$emit('onLoading', false)
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        EventBus.$emit('onLoading', false)
        this.isLoading = false
      })
    },
    setExpireJamList () {
      getExpireJamList({ expireDate: format(addDays(new Date(), 365), 'YYYY-MM-DD') }).then(res => {
        this.expireJamList = res.remainList
      }).catch(err => {
        console.log(err)
      })
    },
    onRegisterDataChange (value) {
      this.registerData = value
    },
    onRevertReferral () {
      setReferralCode({ referral: this.currentReferral, other: false })
        .then(res => {
          this.getCurrentNextPlan()
        })
        .catch(e => {
          console.log(e)
        })
    },
    closeReferral (reload = false) {
      if (reload) this.getCurrentNextPlan()
      this.isRegisteringReferral = false
      this.isModifyingReferral = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .box-layout {
    position: relative;
    padding-top: 33px;
    height: 100%;
    box-sizing: border-box;

    .manage-plan__content {
      height: 100%;
      .toss-view {
        position: absolute;
        top: 200px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
      }
      .content__header {
        @include flexXbetween;
        align-items: center;
        margin-left: 30px;
        margin-right: 30px;
        padding-bottom: 16px;

        h2 {
          font-size: 26px;
          font-weight: 500;
          color: #444444;
          padding-left: 10px;

          span {
            margin-left: 20px;
            font-size: 13px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #767676;
          }
        }

        .button--wrap {
          .btn__change {
            margin-right: 5px;
          }
        }

        .tooltip {
          position: relative;
          top: 12px;
          right: 10px;
          transition: opacity 0.2s ease;

          &::after {
            content: '';
            background-color: #fff;
            position: absolute;
            z-index: 2;
            transform: rotate(-135deg);
            width: 10px;
            height: 10px;
            box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
            top: calc(50% - 6px);
            right: -5px;
          }

          .tooltip-text {
            border-radius: 5px;
            white-space: nowrap;
            box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            padding: 9px 10px;
            color: #444444 !important;
            font-size: 13px;
            line-height: 1;
          }
        }
      }
      .content__body {
        height: calc(100% - 55px);
        padding: 1px 30px 0;
        overflow-y: auto;

        .content--wrap {
          display: flex;
          flex-direction: column;
          position: relative;
          padding: 24px;
          box-sizing: border-box;

          .content__title {
            font-size: 15px;
            font-weight: 500;
            color: #2f2f2f;
            display: inline-block;
            position: relative;
            vertical-align: top;

            .coupon-text {
              margin-left: 9px;
              display: inline-block;
              vertical-align: top;
              text-align: center;
              padding: 0 4px;
              height: 21px;
              box-sizing: border-box;
              line-height: 21px;
              font-size: 12px;
              font-weight: 500;
              color: $brandColor;
              border: solid 1px #ec0047;
              border-radius: 5px;
              position: relative;
              top: -1px;
            }

            .tooltip {
              position: absolute;
              top: -2px;
              margin-left: 6px;
            }
          }
        }

        .content__top {
          @include flexXbetween;

          .content__plan-in-use {
            box-sizing: border-box;

            .content {
              height: 103px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              padding: 36px 0 0 12px;
            }
            .content__plan-wrap {
              display: flex;
              align-items: center;
              .content__my-plan {
                position: relative;
                display: flex;
                flex-direction: column;
                column-gap: 17px;
                row-gap: 6px;
                padding: 0 15px;
                align-items: center;
                .content__my-plan-title {
                  color: #2F2F2F;
                  font-size: 14px;
                  font-weight: 500;
                  line-height: 1;
                }
                .contents__ai-report-info {
                  color: #767676;
                  font-size: 20px;
                  font-weight: 400;
                  .brand-mark {
                    font-weight: 500;
                  }
                }
                .contents__no-ai-report {
                  font-size: 12px;
                  line-height: 1;
                  font-weight: 400;
                }
                &.noCredit {
                  flex-direction: column;
                  align-items: flex-start;
                }
                &:before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 50%;
                  height: 12px;
                  border-left: 1px solid  #d7d7d7;
                  margin-right: 25px;
                  transform: translateY(-50%);
                }
              }
            }
            .content_outer {
              @include flexYcenter;
              .label {
                font-size: 14px;
                font-weight: 500;
                line-height: 1;
                color: #767676;
              }
              .value {
                font-size: 13px;
                line-height: 1;
                color: #444;
              }
            }

            .referral {
              position: absolute;
              bottom: 12px;
              left: 12px;
              height: 34px;
              width: calc(100% - 24px);
              padding: 0 12px;
              display: flex;
              align-items: center;
              gap: 8px;
              background-color: #F4E43A;
              border-radius: 5px;
              font-size: 13px;
              color: #444;
              box-sizing: border-box;
              i.icon {
                background-color: transparent;
                &.icon--bell-till {
                  margin-left: -4px;
                  background-color: #fff;
                  border-radius: 50%;
                }
                &.icon--arrow-body-dark-gray {
                  padding: 0 4px;
                }

              }
              &-label {
              }
              &-code {
                font-weight: 600;
                &.current {
                  color: #0B7D8D;
                }
                &.new {
                  color: #0074FF;
                }
                &.invalid {
                  color: #E60724;
                }
              }
              .apply-btn {
                padding: 8px 12px;
                border-radius: 5px;
                background: #FFF;
                box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
                box-sizing: border-box;
                color: #444;
                font-size: 12px;
                font-weight: 600;
                line-height: 1;
              }
              .edit-btn {
                display: flex;
                padding: 8px;
                border-radius: 50px;
                background: #FFF;
                box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.20);
                box-sizing: border-box;
              }
              .cancel-btn {
                display: flex;
              }
            }
            .content__plan-name {
              padding-right: 15px;
            }

            .plan-name {
              display: block;
              width: 100%;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 500;
              font-size: 30px;
              color: #767676;
              box-sizing: border-box;
              overflow: visible;

              &.using {
                font-size: 40px;
                color: $brandColor;
              }

              .payment-type {
                position: relative;
                margin-left: 15px;

                .icon {
                  vertical-align: middle;
                  transform: translateY(-2px);
                }

                .bubble {
                  @include positionXcenter;
                  bottom: 55px;
                  height: 54px;
                  line-height: 1px;
                  padding: 16px 20px;
                  display: none;
                }

                &:hover {
                  .bubble {
                    display: block;
                  }
                }
              }
            }
            .plan-period {
              position: relative;
              .value {
                margin-top: 10px;
                white-space: nowrap;
              }
            }
            .subscribe--wrap {
              position: relative;
              padding-left: 14px;
              margin-left: 14px;

              &:before {
                display: inline-block;
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                border-left: 1px solid #d7d7d7;
              }

              .description-area {
                display: inline-block;
                vertical-align: middle;
                margin: 5px 11px 5px 0;

                .value {
                  margin-top: 10px;
                }
              }

              .button-area {
                display: inline-block;
                vertical-align: middle;
                margin: 5px 0;
              }
            }
          }
          .content__monthly-pv {
            margin-left: 20px;
            box-sizing: border-box;

            .content {
              flex: 1;
              margin-top: 22px;
              text-align: center;
              .battery--wrap {
                @include flexYcenter;
                justify-content: center;

                /deep/ .battery_wrap_menu {
                  .battery {
                    &:hover:after {
                      display: none;
                    }
                  }
                  .battery-filling {
                    display: inline-block;
                    position: absolute;
                    top: 22px;
                    left: 9px;
                    height: 16px;
                  }
                  .icon--battery {
                    width: 60px;
                    height: 60px;
                    background-size: contain;
                  }
                }

                .value__pv {
                  font-size: 20px;
                  font-weight: 500;
                  color: #666666;
                  margin-left: 10px;
                }
              }
              .remain-pv {
                margin-top: 4px;
                font-size: 18px;
                color: #767676;
                strong {
                  font-weight: 500;
                  color: $brandColor;
                }
              }
              .plan-period {
                margin-top: 10px;
                font-size: 14px;
                line-height: 1.36;
                color: #444444;
              }
            }
            .button--wrap {
              @include flexXcenter;
            }
          }
          .content__jam {
            margin-left: 20px;
            box-sizing: border-box;

            .content {
              flex: 1;
              margin-top: 29px;
              text-align: center;
              .jam--wrap {
                display: flex;
                justify-content: center;
                position: relative;
                .icon--small-jam {
                  width: 50px;
                  height: 64px;
                }
                .icon {
                  width: 64px;
                  height: 64px;
                  background-image: url('https://dream-cdn.beusable.net/analytics/images/jam_bounce.svg');
                  // animation: jam-shake 250ms 1s infinite;
                  &:hover {
                    animation-play-state: paused;
                  }
                }
                .bubble {
                  top: 100%;
                }
              }
              .remain-jam {
                margin-top: 12px;
                font-size: 18px;
                color: #ec0047;
                .value {
                  font-weight: 500;
                }
              }
            }
            .button--wrap {
              @include flexXcenter;
              .button {
                background-color: white;
                border-color: #ec0047;
                /deep/.text {
                  color: #ec0047;
                }
              }
            }
          }
        }
      }
    }

    .content__middle {
      .chart-type {
        margin-top: 32px;
        margin-bottom: -17px;

        button {
          padding: 7px 3px;
          font-weight: 500;
          font-size: 15px;
          margin: 0 15px;
          color: #999999;

          &.on {
            color: #2f2f2f;
            border-bottom: 3px solid #ec0147;
          }

          &:first-child {
            margin-left: 10px;
          }
        }
      }
    }
    .user-applied-plan {
      background: #ffffff;
      color: #2F2F2F;
      border-radius: 14px;
      padding: 30px;
      min-width: 580px;
      box-shadow: 0px 8px 15px 0px rgba(0, 0, 0, 0.16), 0px 0px 0px 1px rgba(0, 0, 0, 0.16);
      .plan-title {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        margin-bottom: 30px;
      }
      .plan-info-wrap {
        .plan-name {
          font-size: 34px;
          font-style: normal;
          font-weight: 600;
          line-height: 34px;
          margin-bottom: 14px;
        }
        .plan-pv-info {
          color: #444;
          font-size: 18px;
          font-weight: 600;
          line-height: 18px;
          margin-bottom: 12px;
        }
      }
      .plan-detail-wrap {
        display: flex;
        .plan-discount-info {
          width: 50%;
          .info-list {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: flex-end;
            gap: 10px;
            .info-item {
              position: relative;
              display: flex;
              justify-content: space-between;
              color: #444;
              font-size: 13px;
              font-weight: 500;
              line-height: 15px;
              &:before {
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 0;
                z-index: -1;
                width: 99%;
                height: 1px;
                background-image: linear-gradient(to right,transparent 50%, #979796 50%);
                background-size: 5px 1px;
              }
              & > div {
                background-color: #fff;
              }
            }
            .info-error {
              color: #EC0047;
              font-size: 13px;
              font-weight: 500;
              line-height: 15px;
            }
          }
        }
        .plan-price-info {
          flex-grow: 1;
          text-align: right;
          .final-price {
            text-align: right;
            font-size: 30px;
            font-weight: 600;
            line-height: 35px;
            margin-bottom: 10px;
          }
          .price-per-month {
            color: #444;
            font-size: 13px;
            font-weight: 500;
            line-height: 15px;
            margin-bottom: 20px;
          }
          .price-payment-btn {
            position: relative;
            display: inline-block;
            background-color: #fff;
            border: 1px solid #bbb;
            box-sizing: border-box;
            white-space: nowrap;
            text-align: center;
            overflow: hidden;
            color: #fff;
            border: 0;
            background-color: #EC0047;
            min-width: 100px;
            height: 38px;
            border-radius: 20px;
            padding: 0 15px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 500;
            transition: background-color 0.2s ease,
                        border-color 0.2s ease,
                        opacity 0.1s ease,
                        color 0.2s ease;
          }
        }
      }
    }
  }

  @keyframes jam-shake {
    0% { transform: translate(0, 0) rotate(0deg); }
    25% { transform: translate(5px, 5px) rotate(5deg); }
    50% { transform: translate(0, 0) rotate(0eg); }
    75% { transform: translate(-5px, 5px) rotate(-5deg); }
    100% { transform: translate(0, 0) rotate(0deg); }
  }
</style>
